import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/folders.action'
import assignCourse from 'api/administration/folders/AssignCourse'
import foldersList from 'api/administration/folders/List'
import I18n from '../../../i18n'
import { ErrorToast, SuccessToast } from 'components/ui/toast/toastsTemplates'

async function getList() {
  return foldersList()
}

async function handleEdit(idFolder: number, idCourse: number) {
  return assignCourse(idFolder, idCourse)
}

function* assignCourseFolderEffectSaga(action: any) {
  const { idFolder, idCourse, onSuccess, onError } = action.payload
  try {
    const res = yield call(handleEdit, idFolder, idCourse)
    const { data } = yield call(getList)
    yield put(fromActions.Actions.foldersAdministrationListSuccess(data))
    onSuccess?.(res)
    SuccessToast(I18n.t('administration.toastMessages.editSuccess'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.editError'))
    onError?.(error)
    yield put(fromActions.Actions.setLoading(false))
    console.log('error: ', error)
  }
}

export function* assignCourseFolderWatcherSaga() {
  yield takeLatest(fromActions.ASSIGN_COURSE, assignCourseFolderEffectSaga)
}
